import { ImageSelectMenu } from "#common";
import { useQuery } from "@tanstack/react-query";
import { get } from "#api";

function FosterDropdown({ value, onChange }) {
  const query = useQuery({
    queryKey: ["fosters"],
    queryFn: () => get(`/user/fosters`),
    initialData: [],
  });
  const handleChange = (v) => {
    onChange({
      target: {
        name: "userId",
        value: v,
      },
    });
  };
  return (
    <div>
      {value && (
        <ImageSelectMenu
          items={query.data}
          selected={value}
          setSelected={handleChange}
        />
      )}
    </div>
  );
}
export default FosterDropdown;
